'use client';
import { subscribeFn } from 'eco-design-micro/apis/subscribeFn';
import { subscribeCookie } from 'eco-design-reliance/cookies/subscribeCookie';
import getLocal from 'eco-design-reliance/getLocal';
import EcoImg from 'eco-design/base/eco-img';
import EcoEmail from 'eco-design/elements/eco-email';
import { DataLayerProps } from 'eco-design-micro/props/DataLayerProps';
import GloLayout from 'lowcode/common/GloLayout';
import { getLocalText } from 'lowcode/plugins/email/SubscribeEmail/config';
import './index.scss';
import { emailPlaceholder } from './common';

export default function Content({ id, data = {} }: any) {
    const { pc, h5, title, subTitle, emarsysType, isAgree = false, TermsOfUseLink = '', PrivacyPolicyLink = '', backgroundColor = '#000' } = data;
    const { locale = 'us' } = getLocal();
    const prefixCls = 'blog-join-email';

    const submitSubscribeHandle1 = ({ email }: any, callback: any) => {
        submitSubscribe(email, callback);
        return true;
    };
    const submitSubscribe = async (email: string, callback: any) => {
        const cookieDataA = subscribeCookie({
            entry_name: 'subscriptionfloating',
            entry_position: 0,
        });
        const res = await subscribeFn(email, emarsysType || 'WEB_REGISTER', locale, cookieDataA);
        if (res?.code === '0') {
            callback('success');
        } else {
            callback('fail', { ...res });
        }
        return true;
    };
    return (
        <GloLayout
            className="editor-blog-join-email"
            id={id}
            style={{ backgroundColor: locale === 'jp' ? backgroundColor : undefined }}
        >
            <div className={` ${prefixCls}-send-container`}>
                <div className={`${prefixCls}-send`}>
                    <div className={`${prefixCls}-send-l`}>
                        <div className={`${prefixCls}-send-title`}>{title}</div>
                        <div className={`${prefixCls}-send-desc`}>{subTitle}</div>
                    </div>
                    <div className={`${prefixCls}-send-r`}>
                        <EcoEmail
                            contactListId={[]}
                            tipsObj={{
                                placeholder: emailPlaceholder[locale as keyof typeof emailPlaceholder],
                            }}
                            termsHtml={getLocalText(locale, TermsOfUseLink, PrivacyPolicyLink).termsAndPolicy}
                            dataLayer={
                                {
                                    event: 'uaEvent',
                                    event_name: 'click_subscribe',
                                    button_name: 'Subscribe',
                                    product_name: '',
                                    module_name: title,
                                } as DataLayerProps
                            }
                            defaultTermsCheck={isAgree}
                            key={`${isAgree}`}
                            onBeforeSendCallback={submitSubscribeHandle1}
                        />
                    </div>
                </div>
                <EcoImg className={`${prefixCls}-bg-img`} pc={pc} h5={h5} />
            </div>
        </GloLayout>
    );
}
